"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _DrupalReminderNugget = _interopRequireDefault(require("./DrupalReminderNugget.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _ReminderNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/ReminderNugget"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = require("../../../../KESI2/KESI2Helper");

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _SettingsCordova = _interopRequireDefault(require("../../SettingsCordova/SettingsCordova.scss"));

var _ThemeProvider = _interopRequireDefault(require("@material-ui/styles/ThemeProvider"));

var _pickers = require("@material-ui/pickers");

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _createMuiTheme = _interopRequireDefault(require("@material-ui/core/styles/createMuiTheme"));

var _colors = require("@material-ui/core/colors");

var _DateTimeHelper = require("../../../../helpers/DateTimeHelper");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _AlarmAdd = _interopRequireDefault(require("@material-ui/icons/AlarmAdd"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Alarm = _interopRequireDefault(require("@material-ui/icons/Alarm"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _Image = _interopRequireDefault(require("../../Image/Image"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'reminderContainer_';
var muiStyles = {
  switchLabel: {
    color: 'black',
    fontSize: 'inherit'
  },
  colorSwitchBase: {
    color: _colors.blue[300],
    '&$colorChecked': {
      color: _colors.blue[500],
      '& + $colorBar': {
        backgroundColor: _colors.blue[500]
      }
    }
  },
  colorBar: {},
  colorChecked: {},
  container: {
    lineHeight: '29px',
    display: 'flex',
    flexWrap: 'wrap'
  },
  pickerContainer: {
    margin: '20px auto',
    textAlign: 'center !important'
  },
  textField: {
    marginLeft: 15,
    // number was guessed
    marginRight: 15,
    // number was guessed
    width: 75
  },
  timeTextField: {
    width: '200px !important'
  }
};

var DrupalReminderNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalReminderNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalReminderNugget);

  function DrupalReminderNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalReminderNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "setDrupalOrUserTimes", function () {
      var nugget = _this.state.content[_this.props.id];
      var userTimes = _DataStore["default"].getElementByPathImmediately("".concat(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_REMINDER, ".").concat(nugget.uuid)) || {};
      var useReminders = true;
      var drupalTimes = nugget.timestamps;

      if ((0, _keys["default"])(userTimes).length === 1 && drupalTimes.length > 1) {
        var firstValue = (0, _values["default"])(userTimes)[0];

        if (firstValue === null) {
          useReminders = false;
        }
      }

      var drupalTimesToSet = {};
      drupalTimes.forEach(function (timestamp, index) {
        drupalTimesToSet[index] = timestamp.value;
      });
      var timesToSet = useReminders ? _objectSpread(_objectSpread({}, drupalTimesToSet), userTimes) : drupalTimesToSet;

      _this.setState({
        timesToRender: timesToSet,
        useReminders: useReminders
      });

      if ((0, _keys["default"])(userTimes).length === 0) {
        _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_REMINDER, ".").concat(nugget.uuid), timesToSet);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "changePushTime", function (newTime) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      newTime.set({
        seconds: 0
      });
      var newTimeStr = "".concat(newTime.hour(), ":").concat(newTime.minutes());
      var newTimeString = (0, _DateTimeHelper.getUtcTimeString)(newTimeStr);
      var userTimes = _this.state.timesToRender;
      userTimes[index] = newTimeString;

      _this.setState({
        timesToRender: _objectSpread({}, userTimes)
      });

      var nugget = _this.state.content[_this.props.id];

      _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_REMINDER, ".").concat(nugget.uuid), userTimes);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "changeUseReminders", function (isChecked) {
      _this.setState({
        useReminders: !isChecked
      });

      var nugget = _this.state.content[_this.props.id];

      if (isChecked) {
        var emptyData = {
          1: null
        };

        _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_REMINDER, ".").concat(nugget.uuid), emptyData);
      } else {
        var userTimes = _this.state.timesToRender;
        console.log('changeUseReminders unchecked', userTimes);

        _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.SCHICHTBOX_REMINDER, ".").concat(nugget.uuid), userTimes);
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getPushTime", function (index) {
      // convert timestamp to local timestamp
      var pushTimeUTC = _this.state.timesToRender[index];

      if (!pushTimeUTC) {
        return;
      }

      var newTimeParts = pushTimeUTC ? pushTimeUTC.split(':') : null;
      var offset = new Date().getTimezoneOffset();

      if (newTimeParts && newTimeParts.length > 1) {
        var newTimeInMinutesInUTC = (0, _parseInt2["default"])(newTimeParts[0]) * 60 + (0, _parseInt2["default"])(newTimeParts[1]);
        var newTimeInMinutes = newTimeInMinutesInUTC - offset;
        var newHours = Math.floor(newTimeInMinutes / 60);
        var newMinutes = newTimeInMinutes % 60;

        if (newHours.toString().length === 1) {
          newHours = "0".concat(newHours);
        }

        if (newMinutes.toString().length === 1) {
          newMinutes = "0".concat(newMinutes);
        }

        return "2020-01-01T".concat(newHours, ":").concat(newMinutes);
      }

      return "2020-01-01T00:00";
    });
    _this.state = _objectSpread({
      waitingForActivation: false,
      mobilePageIndex: 0,
      userTimes: {},
      timerToRender: {},
      useReminders: true
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;

    _this.props.registerNugget(_this.props.id, _ReminderNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalReminderNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalReminderNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var nugget = this.state.content[this.props.id];
      this.registerNuggetPosition(this.props.id, _ReminderNugget["default"].CLASS, this.getDomId());

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      if (nugget.showPreviousResultsOnReopen && nugget.dataStorePath) {
        var path = "".concat(nugget.dataStorePath, "_persist");

        var ids = _DataStore["default"].getElementByPathImmediately(path);

        if (ids) this.setState({
          checkedBoxes: ids
        });
      }

      this.setDrupalOrUserTimes();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalReminderNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      /**
       * @type {ReminderNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var theme = (0, _createMuiTheme["default"])({
        overrides: {
          MuiPickersToolbar: {
            toolbar: {
              backgroundColor: _cssConstants["default"].colors.buttonBackground
            }
          },
          MuiPickersClock: {
            pin: {
              backgroundColor: _cssConstants["default"].colors.buttonBackground
            }
          },
          MuiPickersClockPointer: {
            pointer: {
              backgroundColor: _cssConstants["default"].colors.buttonBackground
            },
            thumb: {
              backgroundColor: _cssConstants["default"].colors.buttonBackground,
              border: "14px solid ".concat(_cssConstants["default"].colors.buttonBackground)
            },
            noPoint: {
              backgroundColor: _cssConstants["default"].colors.buttonBackground
            }
          },
          MuiButton: {
            label: {
              color: _cssConstants["default"].colors.buttonBackground
            }
          }
        }
      });
      console.log('render task', !this.state.useReminders);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "reminderContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: this.getDomId(),
        style: this.props.inSwipeContainer || this.props.inWizardContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "ReminderNugget_".concat(this.props.id, " ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), this.state.timesToRender && (0, _keys["default"])(this.state.timesToRender).length > 0 && /*#__PURE__*/_react["default"].createElement(_ThemeProvider["default"], {
        theme: theme
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          alignContent: 'flex-start'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '10%',
          lineHeight: '100px',
          verticalAlign: 'center',
          textAlign: 'center',
          fontWeight: 'bold'
        }
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '100%',
          fontWeight: 'bold',
          fontSize: '18px'
        },
        classname: "ctnReminderTitle"
      }, nugget.title), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '20px'
        },
        classname: "ctnReminderContent"
      }, nugget.info ? /*#__PURE__*/_react["default"].createElement("div", {
        className: 'info',
        style: {
          paddingBottom: '20px'
        },
        dangerouslySetInnerHTML: {
          __html: nugget.info
        }
      }) : null))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '100%',
          display: 'flex',
          alignContent: 'space-between'
        }
      }, (0, _keys["default"])(this.state.timesToRender).map(function (key) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: "reminder_".concat(key),
          style: muiStyles.pickerContainer
        }, /*#__PURE__*/_react["default"].createElement(_pickers.MuiPickersUtilsProvider, {
          utils: _moment["default"]
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          variant: "contained",
          color: 'primary',
          style: {
            padding: '2px 6px'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Alarm["default"], null))), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            width: 42,
            marginLeft: 5,
            color: 'black !important'
          }
        }, /*#__PURE__*/_react["default"].createElement(_pickers.TimePicker, {
          ampm: false,
          id: "reminder_".concat(key),
          minutesStep: 5,
          value: _this2.getPushTime(key),
          onChange: function onChange(newTime) {
            return _this2.changePushTime(newTime, key);
          },
          okLabel: 'OK',
          InputProps: {
            style: {
              color: 'black',
              textAlign: 'center'
            }
          },
          cancelLabel: 'Abbrechen'
        })))));
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '100%',
          display: 'flex',
          alignContent: 'flex-start',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '40px',
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Alarm["default"], {
        style: {
          color: this.props.lectureBackgroundColor ? _cssConstants["default"].colorMap[this.props.lectureBackgroundColor] : _cssConstants["default"].colors.buttonBackground
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: 'calc(100% - 45px)'
        }
      }, "ber\xFChren, um die Erinnerungszeiten zu \xE4ndern.")), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginTop: '30px',
          width: '100%',
          display: 'flex',
          alignContent: 'flex-start',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '40px',
          textAlign: 'center'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        onChange: function onChange(evt) {
          return _this2.changeUseReminders(evt.target.checked);
        },
        value: !this.state.useReminders,
        checked: !this.state.useReminders,
        style: {
          color: this.props.lectureBackgroundColor ? _cssConstants["default"].colorMap[this.props.lectureBackgroundColor] : _cssConstants["default"].colors.buttonBackground
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: 'calc(100% - 45px)',
          lineHeight: '40px',
          verticalAlign: 'center'
        }
      }, "Keine Erinnerungen f\xFCr diese Aufgabe"))))), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inWizardContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this2.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalReminderNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalReminderNugget;
DrupalReminderNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inWizardContainer: _propTypes["default"].bool.isRequired,
  setStepDone: _propTypes["default"].func,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  registerSendFunc: _propTypes["default"].func,
  setLike: _propTypes["default"].func
};
DrupalReminderNugget.defaultProps = {
  id: null
};